<script setup lang="ts">
import { siteUrl } from '@/configs/urls'
</script>

<template>
  <div class="w-full bg-[#f0f2f5] lg:border-t border-[#9999BF] py-8 px-6 lg:px-24">
    <Container class="w-full">
      <div class="w-full flex flex-col lg:flex-row justify-between gap-6 lg:gap-8">
        <div class="w-full flex flex-col-reverse lg:flex-row gap-6 lg:gap-8">
          <div class="flex flex-col justify-between gap-3 items-start">
            <div class="flex flex-col gap-3 items-start">
              <a :href="siteUrl('/')"> <img class="" src="/img/footer/Logo2.svg" /></a>
              <p class="w-8/12 lg:w-[214px] font-bold text-justify lg:text-start leading-6 text-sm text-[#71757A]">
                در پی‌جیب می‌توانید مبلغ مورد نظرتان را به سرعت و با کم‌ترین کارمزد، از ایران به
                اروپا، استراليا، كانادا و تركيه یا بالعکس، با کمک سایر کاربران پی‌جیب، انتقال دهید.
              </p>
            </div>

            <div class="flex items-center text-[10px] text-[#A0A1A3] gap-1">
              <img class="" src="/img/footer/Group.svg" />
              <span>کلیه حقوق برای پی جیب محفوظ است.</span>
            </div>
          </div>

          <div class="w-full grid grid-cols-2 lg:flex lg:flex-row lg:gap-8">
            <div class="flex flex-col lg:flex-row gap-8 text-sm font-bold text-[#71757A]">
              <!-- <div class="flex flex-col gap-2 items-start">
                <a :href="siteUrl('/terms')">
                  <span>خدمات</span>
                </a>
              </div> -->
              <div class="flex flex-col gap-2 items-start">
                <a :href="siteUrl('/terms')">
                  <span class="text-xs font-normal">پشتیبانی</span>
                </a>
                <a :href="siteUrl('/blog/')">
                  <span class="text-[#2E2EE5]">سوالات پرتکرار</span>
                </a>
                <a :href="siteUrl('/blog/')">
                  <span>چطور کار می‌کند</span>
                </a>
                <a :href="siteUrl('/terms')">
                  <span>قوانین</span>
                </a>
              </div>
              <div class="flex flex-col gap-2 items-start">
                <a :href="siteUrl('/terms')">
                  <span>درباره پی‌جیب</span>
                </a>
                <a :href="siteUrl('/blog/')">
                  <span>وبلاگ</span>
                </a>
              </div>
            </div>
            <div class="grid grid-cols-2 lg:flex flex-row lg:flex-col items-start gap-3">
              <div class="flex flex-col items-start gap-3">
                <div class="text-sm font-bold text-[#71757A] mb-0.5 text-nowrap">
                  تماس با پی‌جیب
                </div>
                <a id="btn-mail" href="mailto:info@payjib.com" class="flex items-center gap-1 font-bold text-[#71757A]">
                  <img class="" src="/img/footer/sms.svg" />
                  <span class="text-[#71757A] text-[13px]">info@payjib.com</span>
                </a>

                <div to="#" class="flex items-start lg:items-center gap-1 text-[14px] font-bold text-[#71757A]">
                  <img class="" src="/img/footer/call.svg" />
                  <div
                    class="flex flex-col lg:flex-row items-center gap-1 lg:gap-2 text-[#71757A] text-[13px] font-bold">
                    <a id="btn-telegram" dir="ltr" href="tel:0 21 2263 2790" class="font-fa text-nowrap">0 21 2263 2790
                    </a>
                    <!-- <span class="hidden lg:block">-</span>
                    <a id="btn-telegram " href="https://t.me/+989356049661" class="ltr text-nowrap">+98 9356049661</a> -->
                  </div>
                </div>

                <div to="#" class="flex items-start lg:items-center gap-1 text-[14px] font-bold text-[#71757A]">
                  <img class="" src="/img/footer/whatsapp.svg" />
                  <div
                    class="flex flex-col lg:flex-row items-center gap-1 lg:gap-2 text-[#71757A] text-[13px] font-bold">
                    <a id="btn-whatsapp" href="https://wa.me/989101369884" dir="ltr"
                      class=" text-nowrap flex items-center gap-1 font-fa">
                      <span>+98</span>
                      9101369884
                    </a>
                    <span class="hidden lg:block">-</span>
                    <a id="btn-whatsapp" href="https://wa.me/989356049661" dir="ltr"
                      class=" text-nowrap flex items-center gap-1 font-fa">
                      <span>+98</span>
                      9356049661
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=609124&Code=lvXgGFcJrtROzjxwsLye02tmeTgO9fRq'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=609124&Code=lvXgGFcJrtROzjxwsLye02tmeTgO9fRq' alt='' style='cursor:pointer' code='lvXgGFcJrtROzjxwsLye02tmeTgO9fRq'></a>
        </div>
      </div>
    </Container>
  </div>
</template>
